import SVGIconWrapper from "./SVGIconWrapper"

const IconCaretLeft = (props) => (
    <SVGIconWrapper
        fill={props.fill ?? "#000000"}
        style={props.style}
        viewBox="0 0 500 500"
        iconClass={`icon--caret-left ${props.iconClass}`}
        wrapperClass={props.wrapperClass}
        onClick={props.onClick}
    >
        <path d="M359.4 500c8.5 0 15.8-3.1 22-9.3s9.3-13.5 9.3-22V31.2c0-8.5-3.1-15.8-9.3-22S367.8 0 359.4 0s-15.8 3.1-22 9.3L118.7 228c-6.2 6.2-9.3 13.5-9.3 22s3.1 15.8 9.3 22l218.8 218.8c6.1 6.1 13.4 9.2 21.9 9.2z" />
    </SVGIconWrapper>
)

export default IconCaretLeft